import { render, staticRenderFns } from "./AffairesItem.vue?vue&type=template&id=52492402&"
import script from "./AffairesItem.vue?vue&type=script&lang=js&"
export * from "./AffairesItem.vue?vue&type=script&lang=js&"
import style0 from "./AffairesItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports